<template>
    <div v-if="isLoading" class="loader-wrapper">
        <div class="loader"></div>
    </div>
    <div v-else>
        <h4 class="mb-2">Create an account</h4>
        <p class="mb-4">Make safety decisions in Real-Time</p>
        <form class="mb-3"  @submit.prevent="registerUser">
            <div class="row">
                <div class="col-md">
                    <div class="mb-3">
                        <label class="form-label">First Name</label>
                        <input type="text" class="form-control" id="firstname" placeholder="Enter first name" required v-model="firstname" autofocus />
                    </div>
                </div>
                <div class="col-md">
                    <div class="mb-3">
                        <label class="form-label">Last Name</label>
                        <input type="text" class="form-control" id="lastname" placeholder="Enter last name" required v-model="lastname" autofocus />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md">
                    <div class="mb-3">
                        <label class="form-label">Company</label>
                        <input type="text" class="form-control" id="company" placeholder="Enter company" required v-model="company" autofocus />
                    </div>
                </div>
                <div class="col-md">
                    <div class="mb-3">
                        <label class="form-label">Phone</label>
                        <input type="text" class="form-control" id="phone" placeholder="Enter phone" required v-model="phone" autofocus />
                    </div>
                </div>
            </div>

            
            <div class="mb-3">
                <label class="form-label">Site Name</label>
                <div class="input-group">
                    <input type="text" class="form-control" id="sitename" placeholder="Enter site name" required v-model="sitename" autofocus />
                    <span class="input-group-text">.safeworkpro.com</span>
                </div>
            </div>

            <div class="mb-3">
                <label class="form-label">Email</label>
                <input type="text" class="form-control" id="email" v-model="email" required placeholder="Enter your email" />
            </div>

            <div class="row">
                <div class="col-md">
                    <div class="mb-3 form-password-toggle">
                        <label class="form-label">Password</label>
                        <div class="input-group input-group-merge">
                            <input :type="showPassword ? 'text' : 'password'" id="password" v-model="password" class="form-control" required placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" aria-describedby="password" />
                            <span class="input-group-text cursor-pointer"><i :class="showPassword ? 'bx bx-hide' : 'bx bx-show'"  @click="togglePassword"></i></span>
                        </div>
                    </div>
                </div>
                <div class="col-md">
                    <div class="mb-3 form-password-toggle">
                        <label class="form-label">Confirm Password</label>
                        <div class="input-group input-group-merge">
                            <input :type="showConfimPassword ? 'text' : 'password'" id="confirmpassword" v-model="confirmpassword" required class="form-control" placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" aria-describedby="confirmpassword" />
                            <span class="input-group-text cursor-pointer"><i :class="showConfimPassword ? 'bx bx-hide' : 'bx bx-show'"  @click="toggleConfirmPassword"></i></span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="mb-3">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="terms-conditions" name="terms" />
                    <label class="form-check-label" for="terms-conditions"> I agree to
                        <a href="javascript:void(0);">privacy policy & terms</a>
                    </label>
                </div>
            </div>
            
            <button class="btn btn-info d-grid w-100">Sign up</button>
            <div v-if="isError" class="alert alert-danger mt-3" role="alert">
                {{ errorMessage }}
            </div>
        </form>

        <p class="text-center">
            <span>Already have an account?</span> <a href="/login"><span>Sign in instead</span></a>
        </p>

    </div>
    


    
</template>

<script>
    import axios from 'axios';
    
    export default {
        data() {
            return {
                firstname: '',
                lastname: '',
                company: '',
                phone: '',
                sitename:'',
                email:'',
                password: '',
                confirmpassword: '',
                showPassword: false,
                showConfimPassword: false,
                isError: false,
                errorMessage: 'Invalid. Please try again.',
                isLoading: false
            };
        },
        methods: {
            togglePassword() {
                this.showPassword = !this.showPassword;
            },
            toggleConfirmPassword() {
                this.showConfimPassword = !this.showConfimPassword;
            },
            validateForm() {
                this.errors = {};
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const alphanumericRegex = /^[a-zA-Z0-9]*$/;

                if (!this.firstname) {
                    this.errorMessage = this.errors.firstname = 'First Name is required';
                }
                else if (this.firstname.length < 3) {
                    this.errorMessage = this.errors.firstname = 'First Name must be at least 3 characters';
                }

                
                if (!this.lastname) {
                    this.errorMessage = this.errors.lastname = 'Last Name is required';
                }
                else if (this.lastname.length < 3) {
                    this.errorMessage = this.errors.lastname = 'Last Name must be at least 3 characters';
                }

                if (!this.company) {
                    this.errorMessage = this.errors.company = 'Company is required';
                }
                else if (this.company.length < 3) {
                    this.errorMessage = this.errors.company = 'Company must be at least 3 characters';
                }

                if (!this.phone) {
                    this.errorMessage = this.errors.phone = 'Phone is required';
                }
                else if (this.phone.length < 10) {
                    this.errorMessage = this.errors.phone = 'Phone must be at least 10 characters';
                }

                
                if (!this.sitename) {
                    this.errorMessage = this.errors.sitename = 'Site Name is required';
                }
                else if (!alphanumericRegex.test(this.sitename)) {
                    this.errorMessage = this.error = 'Site Name must be alphanumeric characters only.';
                }
                else if (this.sitename.length < 3) {
                    this.errorMessage = this.errors.sitename = 'Site Name must be at least 3 characters';
                }

                if (!this.password) {
                    this.errorMessage = this.errors.password = 'Password is required';
                }
                else if (this.password.length < 8) {
                    this.errorMessage = this.errors.password = 'Password must be at least 8 characters';
                }
                else if (this.password != this.confirmpassword) {
                    this.errorMessage = this.errors.password = 'Password not match';
                }

                if (!this.email) {
                    this.errorMessage = this.errors.email = 'Email is required';
                } 
                else if (!this.email.includes('@')) {
                    this.errorMessage = this.errors.email = 'Email is invalid';
                }
                else if (this.email.length < 5) {
                    this.errorMessage = this.errors.email = 'Email must be at least 5 characters';
                }
                else if (!emailRegex.test(this.email)) {
                    this.errorMessage = this.errors.email = 'Please enter a valid email';
                }

                return Object.keys(this.errors).length === 0;
            },
            async checkEmail() {
                try {
                    const res = await axios.post('/auth/check-user');
                    return true;
                } catch (err) {
                    return false;
                }
            },
            async checkWebsite() {
                try {
                    const res = await axios.post('https://' + this.sitename + '.safeworkpro.com/api/show_disk_usage');
                    return false;
                } catch (err) {
                    return true;
                }
            },
            async createUser() {
                axios.post('/api/zoho/customer-signup', 
                    {
                        "contact_persons": {
                            "first_name": this.firstname,
                            "last_name": this.lastname,
                            "email": this.email,
                            "company_name": this.company,
                            "phone": this.phone,
                            "mobile": this.phone,
                            "website": this.sitename + ".safeworkpro.com",
                            "password": this.password,
                            "currency_code": "AUD"
                        },
                        "subscription_plan":{
                            "planCode": "SWPCORE"
                            //"planCode": "SWPCOREAnnaual"
                        },
                        "site_details":{
                            "name": this.sitename
                        }
                    })
                .then((response) => {
                    console.log(response);
                    const data = response.data;
                    if(data.subscription === undefined){
                        this.isLoading = false;
                        this.isError = true;
                        this.errorMessage = data.message;
                    }
                    else{
                        localStorage.setItem('user', data.email);
                        localStorage.setItem('email', data.email);
                        localStorage.setItem('customerId', data.customerId);
                        localStorage.setItem('firstName', data.firstName);
                        localStorage.setItem('lastName', data.lastName);
                        localStorage.setItem('website', data.website);
                        localStorage.setItem('companyName', data.companyName);
                        this.$emit('updateMembershipStatus');
                        this.$router.push('/dashboard'); // Redirect to the dashboard
                    }
                    
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.isError = true;
                    this.errorMessage = error.response.message || 'Registration failed. Try again.';
                });
                
            },
            async registerUser() { 
                this.isLoading = true;
                if (this.validateForm()) {
                    let isSiteValid = await this.checkWebsite()
                    if(isSiteValid){
                        let isEmailValid = await this.checkEmail();
                        if(isEmailValid){
                            this.createUser();
                        }
                        else{
                            this.errorMessage = 'Email already exist';
                            this.isError = true;
                            this.isLoading = false;
                        }
                    }
                    else{
                        this.errorMessage = 'Site name already exist';
                        this.isError = true;
                        this.isLoading = false;
                    }
                }
                else {
                    this.isError = true;
                    this.isLoading = false;
                }
                
            },

        },
    };
</script>


<style scoped>
    .loader-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        background-color: #fff;
    }

    .loader {
        border: 8px solid #f3f3f3;
        border-top: 8px solid #3498db;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>